function normalizeProductListData(productsData, listId, listName) {
	const result = []
	for (const productData of productsData) {
		let { product, variant } = productData
		variant = variant || product.variants.find((x) => x.forDisplay)
		let { prevPrice, price } = variant.pvPrice
		let { sku } = variant
		let { name } = product

		let { categories } = product
		let category
		if (categories?.length) {
			category = categories.map((c) => c.name)
		}
		result.push([sku, name, category, price])
	}

	return result
}

function normalizeProductData(product, variant) {
	variant = variant || product.variants.find((x) => x.forDisplay)
	const sku = variant?.sku
	const name = product.name
	const category = product.categories?.map((c) => c.name) || null
	const price = variant.pvPrice.price

	return [sku, name, category, price]
}

function normalizeCartItemData(product, qty) {
	let variant = product.selectedVariant || product.variants.find((x) => x.forDisplay)
	let { prevPrice, price } = variant.pvPrice
	if (!prevPrice) prevPrice = price
	let { sku } = variant
	let { name } = product

	let { categories } = product
	let category
	if (categories?.length) {
		category = categories.map((c) => c.name)
	}

	return [sku, name, category, price, qty]
}

function normalizeCartOrderItems(items) {
	return items.map((item) => {
		const { sku, name, customData, price, qty } = item
		let category = customData?.categories?.map((c) => c.name) || null

		return [sku, name, category, price, qty]
	})
}

function normalizeOrderData(order) {
	const subtotal = order.items.reduce((acc, item) => acc + item.totalWithSurcharge, 0)

	const totalDelivery = order.deliveries?.reduce((acc, delivery) => acc + delivery.costWithSurcharge, 0)

	return [
		order.code,
		order.total,
		subtotal, // Subtotal sin impuestos/ni envío (opcional)
		0, // Impuestos (opcional)
		totalDelivery, // Costo de envío (opcional)
		Math.abs(order.total - subtotal - totalDelivery), // Descuento aplicado (opcional)
	]
}

module.exports = {
	normalizeProductListData,
	normalizeCartItemData,
	normalizeCartOrderItems,
	normalizeOrderData,
	normalizeProductData,
}

